module.exports = __webpack_public_path__ + "img/bigdata.8143e1a5.png";